import Vue from 'vue'
import Vuex from 'vuex'
import uploader from 'vue-easy-uploader'
import FastClick from 'fastclick'
import App from './App'
import VueRouter from 'vue-router'
import Home from './components/index'
import VueResource from 'vue-resource'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueLazyload from 'vue-lazyload'
import 'swiper/dist/css/swiper.css'
import jquery from 'jquery'
import 'animate.css'
// import clipper from '../static/clipper'



import 'vue-fullpage/vue-fullpage.css'
Vue.config.productionTip = false

import VueFullpage from 'vue-fullpage'
import VueTouch from 'vue-touch'

Vue.use(VueTouch, {name: 'v-touch'})
Vue.use(VueFullpage)
// Vue.use(clipper)

window.$ = jquery;



      /*注册入口路由*/
      import register from './components/register'
      /*微信入口路由*/
      import beforeLogin from './components/beforelogin/beforelogin'
      import firstlogin from './components/beforelogin/firstlogin'
      import dayPay from './components/beforelogin/dayPay'
      import bindSysUser from './components/beforelogin/bindSysUser'

      /*空白页路由后期请删除*/
      import black from './components/black'
      /*缴费入口路由*/
      import pay from './components/payment'
      import water from './components/payComponents/water'
      import electricity from './components/payComponents/electricity'
      import tenement from './components/payComponents/tenement'
      /*用户个人中心路由*/
      import user from './components/userComponents/user'
      import paymentRecord from './components/payComponents/paymentRecord'
      import changeHouse from './components/userComponents/changeHouse'
      import userinfo from './components/userComponents/userInfo'
      import houseBind from './components/userComponents/houseBind'
      import tenementDesc from './components/newComponents/tenementDesc'
      import editUserInformation from './components/userComponents/editUserInformation'

      /*新闻类路由*/
      import listNew from './components/newComponents/listNew'
      import notice from './components/newComponents/notice'
      import detailNew from './components/newComponents/detailNew'
      import infoPublic from './components/newComponents/infoPublic'
      import about from './components/newComponents/about'
      import notice_list from './components/newComponents/notice_list'
      /*黄页服务路由*/
      import yellowPage from './components/convenientComponents/yellowPage'
      import convenientDetail from './components/convenientComponents/convenientDetail'
      import converientList from './components/convenientComponents/convenientList'
      import favorite from './components/convenientComponents/favorite'
      import convenientserver from './components/convenientComponents/server'
      import particular  from './components/convenientComponents/conventientParticular'
      import myEnter from './components/convenientComponents/myEnter'
      import conventientSellDetail from './components/convenientComponents/convenientSellDetail'
      /*投诉建议入口*/
      import complaint from './components/complaintComponenst/complaint'
      import complaintCollect from './components/complaintComponenst/complaintCollect'
      import evaluate from './components/complaintComponenst/evaluate'
      import serviceMultiplePage from './components/complaintComponenst/serviceMultiplePage'

      /*物业报修*/
      import repair from './components/repairComponents/repair'
      import orderlist from './components/repairComponents/orderList'
      import orderDetail from './components/repairComponents/orderDetail'
      import rapireMultiplePage from './components/repairComponents/rapireMultiplePage'
      import imgDome from './components/repairComponents/imgDome'
      // 物业报修新替换页面 静态
      import repairsOne from './components/repairComponents/repairsOne'
      import repairsTwo from './components/repairComponents/repairsTwo'
      import repairsThr from './components/repairComponents/repairsThr'
      /*路由在服务器修改后可删除*/
      import suggest from './components/suggest'
      /*车位租售*/
      import addCar from './components/carRentComponents/addCar'
      import myCarInfo from './components/carRentComponents/myCarInfo'
      import weChatScaner from './components/carRentComponents/weChatScaner'
      import updateCarInfo from './components/carRentComponents/updateCarInfo'
      import myCarInfoList from './components/carRentComponents/myCarInfoList'
      /*字体图标*/
      import '../static/css/style.css'
      import '../static/css/iconfont.css'
      // 车量缴费
      import carPaycoment from './components/carRentComponents/carPaycoment.vue'
      import zhiF from './components/carRentComponents/zhiF.vue'
      import defeated from './components/carRentComponents/defeated.vue'
      import carPayComFee from './components/carRentComponents/carPayComFee'

      //二手市场
      import fleaMarketList from './components/fleaMarketComponents/fleaMarketList'
      import marketDetailList from './components/fleaMarketComponents/marketDetailList'
      import marketResend from './components/fleaMarketComponents/marketResend'
      import marketMyPublish from './components/fleaMarketComponents/marketMyPublish'
      import fleaSendStatus from './components/fleaMarketComponents/fleaSendStatus'
      import commodityMesReply from './components/fleaMarketComponents/commodityMesReply'
      import checkFailure from './components/fleaMarketComponents/checkFailure'
      import myCloct from './components/fleaMarketComponents/myCloct'

      //临时收费
      import relatedToNumber from './components/temporaryCharge/relatedToNumber'
      import feePayment from './components/temporaryCharge/feePayment'
      import customAmout from './components/temporaryCharge/customAmout'
      /*import areaCorrelation from './components/temporaryCharge/areaCorrelation'
      import areaDestory from './components/temporaryCharge/areaDestory'*/
      import decorationCost from './components/temporaryCharge/decorationCost'
      import temporaryPay from './components/temporaryCharge/temporaryPay'

      /*邻里分享*/
      import momentslist from './components/momentsComponents/list.vue'
      import momentsdetail from './components/momentsComponents/detail.vue'
      import momentsmime from './components/momentsComponents/mime.vue'
      import momentspublush from './components/momentsComponents/publish.vue'
      import momentpreview from './components/momentsComponents/preview.vue'

      /*通知中心*/
      import noticeCenter from './components/momentsComponents/remind.vue'

      // 智慧门禁
      import accessControl from './components/entrance/accessControl.vue'  // 我的家属/访客邀请
      import visito from './components/entrance/Visito.vue'  // 做备份
      import addFamily from './components/entrance/addFamily.vue'  // 新增家属
      import addVisitor from './components/entrance/addVisitor.vue'  // 新增访客
      import accessCode from './components/accessControl/accessCode.vue'  // 门禁二维码
      import visitorAuthCode from './components/accessControl/visitorAuthCode.vue'  // 访客授权码
      import visitorAccessQrcode from './components/accessControl/visitorAccessQrcode.vue'  // 访客二维码

      import './style/font-awesome.css'

  //Vue.use(jquery)
     Vue.use(Vuex)
     let store = new Vuex.Store({})
     Vue.use(uploader, store)
      Vue.use(VueRouter)
      Vue.use(VueResource)
      Vue.use(VueAwesomeSwiper)
      Vue.use(VueLazyload)

      const routes = [
      {
        path: '/',
        component: Home
      },
      {
        path: '/visitorAuthCode',
        component: visitorAuthCode
      },
      {
        path: '/visitorAccessQrcode',
        component: visitorAccessQrcode
      },
      {
        path: '/accessCode',
        component: accessCode
      },
      {
        path: '/imgDome',
        component: imgDome
      },
      {
        path: '/accessControl',
        component: accessControl
      },
      {
        path: '/visito',
        component: visito
      },
      {
        path: '/addFamily',
        component: addFamily
      },
      {
        path: '/addVisitor',
        component: addVisitor
      },
      {
        path: '/firstlogin',
        component: firstlogin
      },
      {
        path: '/notice_list',
        component: notice_list
      },
      {
        path:'/serviceMultiplePage',
        component:serviceMultiplePage
      },
      {
        path:'/rapireMultiplePage',
        component:rapireMultiplePage
      },
      {
        path:'/momentspublush',
        component:momentspublush
      },
      {
        path:'/noticeCenter',
        component:noticeCenter
      },
      {
        path:'/momentsmime',
        component:momentsmime
      },
      {
        path:'/momentsdetail',
        component:momentsdetail
      },
      {
        path:'/momentpreview',
        component:momentpreview
      },
      {
        path:'/momentslist',
        component:momentslist
      },
      {
          path: '/complaint',
          component: complaint
      },
      {
          path: '/complaintCollect',
          component: complaintCollect
      },
      {
          path: '/evaluate',
          component: evaluate
      },
      {
          path:'/fleaMarketList',
          component:fleaMarketList
      },
      {
        path:'/marketDetailList',
        component:marketDetailList
      },
      {
        path:'/weChatScaner',
        component:weChatScaner
      },
      {
        path:'/defeated',
        component:defeated
      },
      {
        path:'/marketResend',
        component:marketResend
      },
      {
        path:'/marketMyPublish',
        component:marketMyPublish
      },
      {
        path:'/fleaSendStatus',
        component:fleaSendStatus
      },
      {
        path:'/commodityMesReply',
        component:commodityMesReply
      },
      {
        path:'/checkFailure',
        component:checkFailure
      },
      {
        path:'/myCloct',
        component:myCloct
      },
      /*{
        path:'/areaCorrelation',
        component:areaCorrelation
      },*/
      {
        path:'/temporaryPay',
        component:temporaryPay
      },
      /*{
        path:'/areaDestory',
        component:areaDestory
      },*/
      {
        path:'/decorationCost',
        component:decorationCost
      },
      {
        path:'/relatedToNumber',
        component:relatedToNumber
      },
      {
        path:'/feePayment',
        component:feePayment
      },
      {
        path:'/customAmout',
        component:customAmout
      },
      {
          path: '/orderlist',
          component: orderlist
      },
      {
          path: '/orderDetail',
          component: orderDetail
      },
      {
          path: '/repair',
          component: repair
      },
      {
          path: '/suggest',
          component: suggest
      },
      {
          path: '/myEnter',
          component: myEnter
      },
      {
          path: '/yellowPage',
          component: yellowPage
      },
      {
        path:'/conventientSellDetail',
        component:conventientSellDetail
      },
      {
          path:'/particular',
          component:particular
      },
      {
          path: '/convenientserver',
          component: convenientserver
      },
      {
          path:'/convenientDetail',
          component: convenientDetail,
          children:[
              {
                  path: 'all',
                  component: converientList
              },
              {
                  path: 'favorite',
                  component: favorite
              },
          ]
      },
      {
        path: '/black',
        component: black
      },
      {
        path: '/about',
        component: about
      },
      {
        path: '/beforeLogin',
        component: beforeLogin
      },
      {
        path: '/dayPay',
        component: dayPay
      },
      {
        path: '/bindSysUser',
        component: bindSysUser
      },
      {
        path: '/register',
        component: register
      },
      {
        path: '/houseBind',
        component: houseBind
      },
      {
        path: '/user',
        component: user,
      },
      {
        path: '/changeHouse',
        component: changeHouse
      },
      {
        path:'/userinfo',
        component:userinfo
      },
      {
        path: '/listNew',
        component: listNew
      },
      {
        path:'/notice',
        component:notice
      },
      {
        path:'/detailNew',
        component:detailNew
      },
      {
        path:'/tenementDesc',
        component:tenementDesc
      },
      {
        path:'/paymentRecord',
        component:paymentRecord
      },
      {
        path:'/infoPublic',
        component:infoPublic
      },
      {
        path: '/pay',
        component: pay,
        children:[
          {
            path: 'water',
            component: water
          },
          {
            path: 'electricity',
            component: electricity
          },
          {
            path: 'tenement',
            component: tenement
          }
        ]
      },
      {
        path:'/addCar',
        component:addCar
      },
      {
        path:'/myCarInfo',
        component:myCarInfo
      },
      {
        path:'/updateCarInfo',
        component:updateCarInfo
      },
      {
        path:'/myCarInfoList',
        component:myCarInfoList
      },
      {
        path:'/carPaycoment',
        component:carPaycoment
      },
      {
        path:'/zhiF',
        component:zhiF
      },
      {
        path:'/carPayComFee',
        component:carPayComFee
      },
      {
        path:'/editUserInformation',
        component:editUserInformation
      },
      {
        path:'/repairsOne',
        component:repairsOne
      },
      {
        path:'/repairsTwo',
        component:repairsTwo
      },
      {
        path:'/repairsThr',
        component:repairsThr
      },

      ]

const router = new VueRouter({
  mode: 'history',
  base:'movecouplet',
  routes
})

FastClick.attach(document.body)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  router,

  render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js